









































import { Component, Vue } from 'vue-property-decorator'
import GlassTypeTile from './ui/GlassTypeTile.vue'
import OptionModule from '@/components/OptionModule.vue'
import { IGlassType } from '@/data/glass-type'
import GlassOption, { getOptionRoute } from '@/data/glass-option'
import { ModuleOption, InformationCodes } from '@/data/enums'
import GlassOptionValue from '@/data/glass-option-value'

@Component({
  components: {
    GlassTypeTile,
    OptionModule
  }
})
export default class GlassType extends Vue {
  public $refs!: {
    main: HTMLElement
    container: HTMLElement
  }
  private mainWidth: number = 0
  private containerWidth: number = 0
  private maxPosition: number = 0
  private minPosition: number = 0
  private position: number = 0
  private isDragging: boolean = false
  private animate: boolean = false
  private snapPosition: number = 0
  private startPosition: number = 0
  private startX: number = 0
  private animationTimerId?: number
  private currentIndex = 0

  private defaultIndex (): number {
    if (this.items) {
      const defaultGlassesIndex = this.items.findIndex((item: IGlassType) => (item.isDefault))
      let dneye = false
      let impressionist = false
      let setIndex = -1

      if (this.$store.state.cart.currentItem.dneye) {
        dneye = true
      }
      if (this.$store.state.cart.currentItem.impressionist) {
        impressionist = true
      }
      if (dneye && impressionist) {
        setIndex = this.items.findIndex((item: IGlassType) =>
          (item.hasDneye && item.hasImpressionist)) // both
      } else if (dneye && !impressionist) {
        setIndex = this.items.findIndex((item: IGlassType) =>
          (item.hasDneye)) // only dneye
      } else if (!dneye && impressionist) {
        setIndex = this.items.findIndex((item: IGlassType) =>
          (item.hasImpressionist)) // only impressionist
      } else if (!dneye && !impressionist && defaultGlassesIndex !== -1) { // default
        setIndex = defaultGlassesIndex
      } else {
        setIndex = Math.floor(this.items.length / 2)
      }
      if (setIndex !== -1) {
        return setIndex
      }
    }

    return 0
  }

  private get glasses (): string {
    if (this.$store.state.cart.currentItem !== undefined) {
      return this.$store.state.cart.currentItem.glasses.name
    }
    return 'Bril'
  }

  private get informationCode (): InformationCodes | boolean {
    if (this.$store.state.cart.currentItem !== undefined) {
      return this.$store.state.cart.currentItem.glasses.informationCode
    }
    return false
  }

  private get items (): IGlassType[] {
    if (this.$store.state.cart.currentItem) {
      return this.$store.state.cart.currentItem.glasses.glassTypes
    } else {
      return []
    }
  }

  private get previous (): string {
    // check if optician has impressionist
    const hasImpressionist = this.$store.state.data.optician.impressionist
    const hasDneye = this.$store.state.data.optician.dneye
    let path = '/glasses/impressionist'
    if (!hasImpressionist && !hasDneye) {
      path = '/glasses'
    }
    if (!hasImpressionist && hasDneye) {
      path = '/glasses/dneye'
    }

    if (hasImpressionist && hasDneye) {
      path = '/glasses/impressionist'
    }

    const count = this.$store.state.cart.items.length
    if (count > 1) { // skip if more then 2 items
      path = '/glasses'
    }
    return path
  }

  private get nextModule (): string {
    let nextRoute = '/cart'
    if (this.items[this.currentIndex]) {
      const options = this.items[this.currentIndex].options.filter((option) => option.optionId !== 5)
      const fullscreenOptions = this.items[this.currentIndex].options
        .filter((option) => (option.optionId !== 5 && option.fullscreen === 1))
      if (fullscreenOptions.length) {
        nextRoute = getOptionRoute(fullscreenOptions[0].optionId)
      } else if (options.length) {
        return '/glasses/extra'
      }
    }
    return nextRoute
  }

  private get positions (): number[] {
    const positions = []
    if (this.items) {
      for (let i = 0; i < this.items.length; i++) {
        positions.push((i * (430 + 40)))
      }
    }
    return positions
  }

  private mounted () {
    // fire selectglasstype to update prices
    for (const item of this.items) {
      this.$store.dispatch('cart/selectGlassType', item).catch((err) => console.error(err))
    }
    this.bindEvents()
    this.getSize()
    this.currentIndex = this.defaultIndex()
    this.goToIndex(this.currentIndex)
  }

  private beforeDestroy () {
    clearTimeout(this.animationTimerId)
    this.unBindEvents()
  }

  private isAlpha (index: number) {
    return (index === this.currentIndex || index === this.currentIndex - 1 || index === this.currentIndex + 1)
  }

  private getSize () {
    this.mainWidth = this.$refs.main.clientWidth
    if (this.items) {
      this.containerWidth = this.items.length * (430 + 40) + 40
    }
    this.maxPosition = this.mainWidth / 2 - 255
    this.minPosition = this.maxPosition - this.containerWidth
    this.position = this.maxPosition
    this.goToIndex(this.currentIndex)
  }

  private bindEvents () {
    document.addEventListener('touchmove', this.dragMove, { passive: false })
    document.addEventListener('touchend', this.dragUp, { passive: false })
    this.$refs.container.addEventListener('touchstart', this.dragDown, { passive: false })
    this.$refs.container.addEventListener('mousedown', this.dragDown)
    document.addEventListener('mousemove', this.dragMove)
    document.addEventListener('mouseup', this.dragUp)
    document.addEventListener('mouseleave', this.dragUp)
    window.addEventListener('resize', this.onResize)
  }

  private unBindEvents () {
    document.removeEventListener('touchmove', this.dragMove)
    document.removeEventListener('touchend', this.dragUp)
    this.$refs.container.removeEventListener('touchstart', this.dragDown)
    this.$refs.container.removeEventListener('mousedown', this.dragDown)
    document.removeEventListener('mousemove', this.dragMove)
    document.removeEventListener('mouseup', this.dragUp)
    document.removeEventListener('mouseleave', this.dragUp)
    window.removeEventListener('resize', this.onResize)
  }

  private onResize () {
    this.getSize()
  }

  private dragDown (e: MouseEvent | TouchEvent) {
    const event = 'targetTouches' in e ? e.targetTouches[0] : e
    this.animate = false
    this.isDragging = true
    this.startX = event.pageX
    this.startPosition = this.position
    clearTimeout(this.animationTimerId)
    this.dragMove(e)
  }

  private dragMove (e: MouseEvent | TouchEvent) {
    const event = 'targetTouches' in e ? e.targetTouches[0] : e
    if (this.isDragging) {
      let changeX = this.startPosition + (event.pageX - this.startX)

      // constrain
      if (changeX > this.maxPosition) {
        changeX = this.maxPosition
      }
      if (changeX < this.minPosition) {
        changeX = this.minPosition
      }

      // check
      if (changeX !== this.position) {
        this.position = changeX
        const find = this.maxPosition - changeX
        const closest = this.positions.reduce((
          prev: number,
          curr: number
        ) => {
          return Math.abs(curr - find) < Math.abs(prev - find) ? curr : prev
        })
        const index = this.positions.indexOf(closest)
        this.snapPosition = closest
        this.goToIndex(index)
      }
    }
  }

  private goToIndex (index: number) {
    this.currentIndex = index
    this.snapPosition = this.positions[index]
    this.dragUp()
    this.$store.dispatch('cart/selectGlassType', this.items[index])
      .catch((err) => console.error(err))

    this.items[index].options.forEach((option: GlassOption) => {
      if (option.optionId !== ModuleOption.Suncolor && option.optionId !== ModuleOption.Dneye) {
        const selectedValue = option.values.find((optionValue: GlassOptionValue) => optionValue.selected)
        if (!selectedValue) {
          option.values.forEach((optionValue: GlassOptionValue) => {
            if (optionValue.isDefault && !optionValue.selected) {
              this.$store.dispatch('cart/toggleOptionValue', optionValue).catch((err) => console.error(err))
            }
          })
        }
      }
    })
  }

  private stopAnimate () {
    this.animate = false
  }

  private dragUp () {
    this.animate = true
    this.position = this.maxPosition - this.snapPosition
    this.animationTimerId = setTimeout(this.stopAnimate, 250)
    this.isDragging = false
  }
}
